// SCREENINGS Store
import store from ".."

const state = {
  STATUS: null,
  API_ROUTE: "/screenings/m0", //Default route = ALL
  API_ROUTE_DAY: "/d/",
  API_ROUTE_WEEK: "/screenings/w",
  API_ROUTE_MONTH: "/screenings/m",
  API_ROUTE_3MONTH: "/screenings/m3",
  API_ROUTE_6MONTH: "/screenings/m6",
  API_ROUTE_YEAR: "/screenings/y",
  API_ROUTE_HOLDS: "/screenings/onhold",
  API_ROUTE_STATUS: "/screening/", //  "/screening-status"
  API_ROUTE_CRUD: "/screening/",
  API_ROUTE_BYORGID: "/byorgid/",
  API_ROUTE_DELETE_TESTS: "/screening/test",
  kioskID: "",
  screenings: []
}

const getters = {
  screenings: (state) => {
    return state.screenings
  }
}

// Called from Action to change State
const mutations = {
  getScreenings(state, screenings) {
    screenings.forEach((item) => {
      try {
        let fl = item.firstName.trim() + " " + item.lastName.trim()
        let lf = item.lastName.trim() + ", " + item.firstName.trim()
        item.firstName = fl
        item.lastName = lf
      } catch (error) {
        console.log("getScreeningsERR: " + error)
      }
    })
    state.screenings = screenings
  },
  SORT_SCREENINGS(state, sort) {
    state.screenings = sort
  }
}

// Called externally to commit a State Mutation
const actions = {
  async loadScreenings({ commit }, payload) {
    if (payload.hold) {
      if (payload.admin) {
        var url = process.env.VUE_APP_URL + state.API_ROUTE_HOLDS + "null"
      } else {
        var url = process.env.VUE_APP_URL + state.API_ROUTE_HOLDS // + sessionStorage.getItem("userID");
      }
    } else {
      if (payload.filter === "d") {
        var url = process.env.VUE_APP_URL + state.API_ROUTE_DAY // + payload.kioskID;
      } else if (payload.filter === "w") {
        var url = process.env.VUE_APP_URL + state.API_ROUTE_WEEK // + payload.kioskID;
      } else if (payload.filter === "m") {
        var url = process.env.VUE_APP_URL + state.API_ROUTE_MONTH // + payload.kioskID;
      } else if (payload.filter === "m3") {
        var url = process.env.VUE_APP_URL + state.API_ROUTE_3MONTH // + payload.kioskID;
      } else if (payload.filter === "m6") {
        var url = process.env.VUE_APP_URL + state.API_ROUTE_6MONTH // + payload.kioskID;
      } else if (payload.filter === "y") {
        var url = process.env.VUE_APP_URL + state.API_ROUTE_YEAR // + payload.kioskID;
      } else var url = process.env.VUE_APP_URL + state.API_ROUTE // + payload.kioskID;
    }

    // attatch requestor to URL for OrgID filter
    var url = url + "/" + sessionStorage.getItem("username")

    const config = {
      headers: {
        "Content-Type": "application/json"
        //'Access-Control-Allow-Origin': '*',
      }
    }
    const data = null
    state.kioskID = payload.kioskID
    //console.log(" .       .       .       .      ." )
    //console.log("**LOAD SCREENINGS: " + url )
    await window.axios
      .get(url, data, config)
      .then((r) => r.data)
      .then((screenings) => {
        //console.log(screenings)
        commit("getScreenings", screenings)
      })
      .catch(function (error) {
        state.STATUS = "An error occurred: " + error
        console.log(state.STATUS)
      })
  },
  async setScreeningOngoing({ commit }, payload) {
    var url = process.env.VUE_APP_URL + state.API_ROUTE_STATUS
    url += sessionStorage.getItem("screeningID") + "/Ongoing/" // + sessionStorage.getItem("userID");
    await window.axios
      .put(url)
      .then(() => {
        console.log("Screening status updated.")
      })
      .catch(function (error) {
        console.log("An error occurred during status update")
      })
  },
  sortScreenings({ commit }, sort) {
    commit("SORT_SCREENINGS", sort)
  },
  deleteAllTestPatients() {
    return new Promise((resolve, reject) => {
      var url = process.env.VUE_APP_URL + state.API_ROUTE_DELETE_TESTS
      window.axios
        .delete(url)
        .then(() => {
          resolve(true)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  deleteScreening({ commit }, id) {
    return new Promise((resolve, reject) => {
      var url = process.env.VUE_APP_URL + state.API_ROUTE_CRUD + id
      window.axios
        .delete(url)
        .then(() => {
          resolve(true)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  async updateFindings({ commit }, { payload, status = "hold" }) {
    const finalStatus = status === "Save" ? "hold" : status

    const screeningID = sessionStorage.getItem("screeningID")
    const userID = sessionStorage.getItem("userID")
    const config = { headers: { "Content-Type": "application/json" } }
    const url = `${process.env.VUE_APP_URL}/screening/${screeningID}/${finalStatus}/${userID}`

    try {
      const response = await window.axios.put(url, payload, config)
      return response.data
    } catch (error) {
      console.error("Error updating screening:", error)
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
